import { PropsFromInputs } from '../../types';

import { Container, Waves } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ size, variant }: Props) => {
  return (
    <Container $variant={variant}>
      <Waves $size={size} />
    </Container>
  );
};
